import Promise from 'promise-polyfill';
import 'shariff';
import './Polyfills';
import { addClass, hasClass, removeClass } from '../tools/helpers';
import initScrollers, { scrollToElement } from './MoreBtns';
import bp from './vars';
import './cards';
import './accordeons';
import './symbolCards';
import './footerCards';
import './lightbox';
import './videoModal';
// import cookieCheck from './cookieBanner';

const nav = document.querySelectorAll('.mainnav')[0];
const navDummy = document.querySelectorAll('.mainnav-dummy')[0];
const header = document.querySelectorAll('.page-header')[0];
const navToggle = document.querySelectorAll('.nav-toggle')[0];
const navItems = document.querySelectorAll('[data-jump]');
const articles = document.querySelectorAll('.article');
const introCTA = document.querySelectorAll('.intro__cta')[0];
const homeButton = document.querySelector('.mainnav__item');

let currentObjects = [
  ...document.querySelectorAll('.intro'), // animate on first render
  ...document.querySelectorAll('.hero'),  // animate on first render
];

let isTransitioning = false; // prevent elements state updates while scrolling
const timeouts = [];

function dock() {
  nav.style.width = `${navDummy.offsetWidth}px`;
  addClass(nav, 'mainnav--stuck');
}

function undock() {
  nav.setAttribute('style', '');
  removeClass(nav, 'mainnav--stuck');
}

function openNav() {
  removeClass(nav, 'mainnav--closed');
  if (window.innerWidth < bp.XL) {
    addClass(header, 'page-header--shadow');
    addClass(navToggle, 'nav-toggle--open');
  }
}

function closeNav() {
  addClass(nav, 'mainnav--closed');
  if (window.innerWidth < bp.XL) {
    removeClass(header, 'page-header--shadow');
    removeClass(navToggle, 'nav-toggle--open');
  }
}

function observeScrolling() {
  if (isTransitioning) {
    return null;
  }

  currentObjects.forEach((node) => {
    const rect = node.getBoundingClientRect();
    if (rect.top <= (window.innerHeight * 0.75)) {
      if (
        hasClass(node, 'intro') ||
        hasClass(node, 'top-content') ||
        hasClass(node, 'bottom-content') ||
        hasClass(node, 'accordeon') ||
        hasClass(node, 'content__header') ||
        hasClass(node, 'main-cards') ||
        hasClass(node, 'career-cta') ||
        hasClass(node, 'video-section') ||
        hasClass(node, 'footer-cards')) {
        removeClass(node, 'hidden');
        removeClass(node, 'slide-out-up');
      }
    }

    if (rect.top <= (window.innerHeight * 0.85)) {

      if (hasClass(node, 'main-cards')) {
        node.querySelectorAll('.card, .symbol-card').forEach((card, index) => {
          setTimeout(() => {
            removeClass(card, 'card--hidden');
            removeClass(card, 'slide-out-up');
          }, 300 + (index * 150)); // offset
        });
      }

      if (hasClass(node, 'accordeon')) {
        node.querySelectorAll('.accordeonItem').forEach((item, index) => {
          setTimeout(() => {
            removeClass(item, 'item--hidden');
            removeClass(item, 'slide-out-up');
          }, 300 + (index * 150)); // offset
        });
      }

      if (hasClass(node, 'footer-cards')) {
        node.querySelectorAll('.simple-card').forEach((item, index) => {
          setTimeout(() => {
            removeClass(item, 'card--hidden');
            removeClass(item, 'slide-out-up');
          }, 300 + (index * 150)); // offset
        });
      }

      if (hasClass(node, 'video-section')) {
        removeClass(node, 'hidden');
        const headerSection = node.querySelector('.content__header');
        removeClass(headerSection, 'hidden');
      }
    }

    if (rect.top <= (window.innerHeight * 1.1)) {
      if (hasClass(node, 'career-cta')) {
        removeClass(node, 'hidden');
        removeClass(node, 'slide-out-up');
      }
    }

    // Ensure headers are revealed after jump-to-section
    if (rect.top <= 0 && hasClass(node, 'content__header')) {
      removeClass(node, 'hidden');
    }

    return null;
  });

  // open nav on scroll for larger screens
  if (
    hasClass(nav, 'mainnav--closed') &&
    navDummy.getBoundingClientRect().top <= window.innerHeight * 0.85 &&
    window.innerWidth >= bp.XL
  ) {
    openNav();
  }

  if (navDummy.getBoundingClientRect().top <= 0 && window.innerWidth >= bp.XL) {
    dock();
  } else {
    undock();
  }

  return null;
}

function onResize() {
  if (window.innerWidth < bp.XL) {
    nav.setAttribute('style', '');
    closeNav();
  } else {
    nav.style.width = `${navDummy.offsetWidth}px`;
    openNav();
  }
}

function preloadImages(elId) {
  const article = document.getElementById(elId);
  article.querySelectorAll('[data-bg]').forEach((div) => {
    const src = div.getAttribute('data-bg');
    const img = document.createElement('img');
    img.addEventListener('load', () => {
      // first image
      /* eslint-disable no-param-reassign */
      div.style.backgroundImage = `url(${src})`;
      // blurred image IE compatible
      const blurredStr = `
        <svg class="card__img card__img--blurred" viewBox="0 0 ${this.naturalWidth} ${this.naturalHeight}" preserveAspectRatio="xMidYMid slice">
          <filter id="img-blur">
            <feGaussianBlur stdDeviation="5" />
          </filter>
          <image xlink:href="${src}" filter="url(#img-blur)" width="${this.naturalWidth}" height="${this.naturalHeight}"></image>
        </svg>
      `;
      const range = document.createRange();
      range.selectNode(div);
      div.parentNode.appendChild(range.createContextualFragment(blurredStr));
      const svg = div.parentNode.querySelector('svg');
      // promote this element
      svg.style.willChange = 'opacity';
    });
    img.src = src;
  });
}

function addNewArticle(target) {
  const targetArticle = document.getElementById(target);
  addClass(targetArticle, 'article--active');

  currentObjects = [
    ...targetArticle.querySelectorAll('.top-content'),
    ...targetArticle.querySelectorAll('.bottom-content'),
    ...targetArticle.querySelectorAll('.main-cards'),
    ...targetArticle.querySelectorAll('.accordeon'),
    ...targetArticle.querySelectorAll('.content__header'),
    ...targetArticle.querySelectorAll('.career-cta'),
    ...targetArticle.querySelectorAll('.video-section'),
    ...targetArticle.querySelectorAll('.footer-cards'),
  ];
  observeScrolling();
}

function selectArticle(evt) {
  if (evt.preventDefault) {
    evt.preventDefault();
  }
  let navTargetAnchor;

  if (evt.type === 'click') { // event came from navigation or card item click
    const targetStr = evt.currentTarget.getAttribute('data-jump');
    history.pushState(`#${targetStr}`, null, `#${targetStr}`);
    navTargetAnchor = document.querySelectorAll(`[href="#${targetStr}"]`)[0];
  } else if (evt.type === 'popstate') { // event came from browser history
    navTargetAnchor = document.querySelectorAll(`[href="${evt.state}"]`)[0];
  } else if (typeof evt === 'string') { // arbitrary state trigger
    navTargetAnchor = document.querySelectorAll(evt)[0];
  }

  const currentArticle = document.querySelectorAll('.article--active')[0];
  const nextArticle = navTargetAnchor.getAttribute('href').slice(1);

  if (currentArticle.id === 'privacy-policy') {
    // cookieCheck();
  }

  preloadImages(nextArticle);

  // deactivate currentItems
  removeClass(nav, 'mainnav__items--inactive');
  navItems.forEach((node) => {
    removeClass(node.parentNode, 'mainnav__item--active');
  });
  // activate the new navigation item
  if (hasClass(navTargetAnchor.parentNode, 'mainnav__item')) {
    addClass(navTargetAnchor.parentNode, 'mainnav__item--active');
  }

  // automatically close navigation on mobile
  if (window.innerWidth < bp.XL) {
    closeNav();
  }

  // spread all elements in all queries inside this array
  const els = [
    ...currentArticle.querySelectorAll('.career-cta'),
    ...currentArticle.querySelectorAll('.content__header'),
    ...currentArticle.querySelectorAll('.content__header--moreBtns'),
    ...currentArticle.querySelectorAll('.top-content'),
    ...currentArticle.querySelectorAll('.content__header--main-cards'),
    ...currentArticle.querySelectorAll('.card'),
    ...currentArticle.querySelectorAll('.symbol-card'),
    ...currentArticle.querySelectorAll('.accordeonItem'),
    ...currentArticle.querySelectorAll('.content__header--accordeon'),
    ...currentArticle.querySelectorAll('.simple-card'),
    ...currentArticle.querySelectorAll('.bottom-content'),
    ...currentArticle.querySelectorAll('.main-cards'),
    ...currentArticle.querySelectorAll('.content__header--video-section'),
    ...currentArticle.querySelectorAll('.video-section'),
    ...currentArticle.querySelectorAll('.footer-cards'),
  ];

  // if there is any animation currently running, reset it
  if (timeouts.length) {
    timeouts.forEach(tm => clearTimeout(tm));
    timeouts.length = 0;
  }

  // fade all elements and change article when all are complete
  Promise.all(els.map((el, index) => new Promise((resolve) => {
    isTransitioning = true;

    timeouts.push(
      setTimeout(() => {
        resolve(el);
        addClass(el, 'slide-out-up');
        removeClass(el, 'hidden');
      }, 100 * index),
    );

  }))).then((res) => {
    removeClass(document.getElementsByClassName('slide-out-up'), 'slide-out-up');
    // reset each item
    res.forEach((el) => {
      if (hasClass(el, 'card') || hasClass(el, 'symbol-card') || hasClass(el, 'simple-card')) {
        addClass(el, 'card--hidden');
      } else if (hasClass(el, 'accordeonItem')) {
        addClass(el, 'item--hidden');
      } else {
        addClass(el, 'hidden');
      }
    });
    // deactivate current article and add new one
    removeClass(articles, 'article--active');
    isTransitioning = false;
    if (window.innerWidth < 1220) {
      // extra offset for header bar
      scrollToElement('main-content', null, -54);
    } else {
      scrollToElement('main-content');
    }
    addNewArticle(nextArticle);

  }).catch((reason) => {
    console.info('Promises fail. Reason:', reason);
  });
}

function init() {
  // cookieCheck();

  // Navigation Toggle on mobile
  navToggle.addEventListener('click', (evt) => {
    if (hasClass(evt.currentTarget, 'nav-toggle--open')) {
      closeNav();
    } else {
      openNav();
    }
  });

  // orange scroll button
  introCTA.addEventListener('click', () => scrollToElement((window.innerWidth < bp.SM) ? 'intro-content' : 'main-content'));

  // navigation event listeners
  navItems.forEach(navitem => navitem.addEventListener('click', selectArticle));
  window.addEventListener('popstate', selectArticle);

  // special case home button active
  navItems.forEach(navitem => navitem.addEventListener('click', () => removeClass(nav, 'mainnav--inactive')));
  homeButton.addEventListener('click', () => addClass(nav, 'mainnav--inactive'));

  // user events
  document.addEventListener('scroll', observeScrolling);
  window.addEventListener('resize', onResize);

  initScrollers();

  // kickstart this thing
  // default url value is home
  let article = 'home';
  // unless there is some hash in the url
  if (location.hash) {
    article = location.hash.slice(1);
    if (article !== 'home') {
      removeClass(nav, 'mainnav--inactive');
    } else {
      addClass(homeButton, 'mainnav__item--active');
    }
    const activeItem = [...navItems].filter(item => item.getAttribute('data-jump') === article);
    addClass(activeItem[0].parentNode, 'mainnav__item--active');
    /* addClass(navTargetAnchor.parentNode, 'mainnav__item--active') */
  } else {
    addClass(homeButton, 'mainnav__item--active');
  }
  // show header and load initial article
  setTimeout(() => {
    removeClass(document.querySelectorAll('.intro, .hero'), 'hidden');
    /* removeClass(document.getElementsByClassName('.career-cta'), 'hidden'); */
    preloadImages(article);
    addNewArticle(article);
  }, 1000);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}



// WEBPACK FOOTER //
// ./src/javascript/main/index.js